export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      4990.839002267574,
    ],
    book_fly_flip_pages: [
      6000,
      5983.492063492064,
    ],
    book_react: [
      13000,
      1911.292517006803,
    ],
    button_spin: [
      16000,
      854.7845804988654,
    ],
    counter_total: [
      18000,
      432.47165532879706,
    ],
    end_free_spin: [
      20000,
      4715.102040816326,
    ],
    end_free_spin_loop: [
      26000,
      6865.850340136056,
    ],
    free_bet_big_win: [
      34000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      37000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      41000,
      979.5918367346915,
    ],
    free_bet_ultra_win: [
      43000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      46000,
      36838.45804988661,
    ],
    free_spin_music: [
      84000,
      68423.40136054423,
    ],
    free_spin_start: [
      154000,
      3240.634920634932,
    ],
    inside_buttons: [
      159000,
      399.0929705215365,
    ],
    main_ambient: [
      161000,
      61484.988662131516,
    ],
    main_music: [
      224000,
      153621.768707483,
    ],
    mega_win: [
      379000,
      4334.875283446707,
    ],
    outside_button: [
      385000,
      396.1904761904975,
    ],
    page_flies_away: [
      387000,
      1107.301587301606,
    ],
    reel_spin: [
      390000,
      2059.319727891136,
    ],
    reel_stop_01: [
      394000,
      126.25850340134548,
    ],
    reel_stop_02: [
      396000,
      134.9659863945476,
    ],
    reel_stop_03: [
      398000,
      140.77097505668235,
    ],
    reel_stop_04: [
      400000,
      123.3560090702781,
    ],
    reel_stop_05: [
      402000,
      117.55102040814336,
    ],
    regular_win: [
      404000,
      1464.3083900226657,
    ],
    respin: [
      407000,
      3850.158730158739,
    ],
    scatter_chance: [
      412000,
      3748.571428571438,
    ],
    scatter_stop: [
      417000,
      912.8344671202058,
    ],
    show_bonus_game: [
      419000,
      2599.1836734693834,
    ],
    tap_to_play: [
      423000,
      3054.8752834467336,
    ],
    ultra_win: [
      428000,
      4555.464852607713,
    ],
    x1_mult: [
      434000,
      1255.3287981859285,
    ],
    x3_mult: [
      437000,
      1348.2086167800276,
    ],
    x5_mult: [
      440000,
      1795.1927437641757,
    ],
    x7_mult: [
      443000,
      2297.324263038547,
    ],
    x9_mult: [
      447000,
      3057.777777777801,
    ],
  },
}
